import React, { useState } from 'react';
import { GetAllCarriers_getAllCarriers as Carrier } from '../../../types/schemaTypes';
import './CarrierItem.scss';
import DeleteModal from '../../JobProfile/DeleteModal';
import { formatDateUtcToLocal } from '../../../utils/helpers/datetimeHelper';

interface Option {
    id: number | string;
    name: string | number;
}

interface CarrierItemProps {
    carrier: Carrier;
    options: Option[];
    index: number;
    canEditCarriers: boolean;
    canAddEditLogisticsPartner: boolean;
    onEditClick: (carrier: Carrier) => void;
    onDelete?: (record: any) => void;
}

const CarrierItem = ({
    carrier,
    options,
    index,
    onEditClick,
    onDelete,
    canEditCarriers,
    canAddEditLogisticsPartner,
}: CarrierItemProps): React.ReactElement => {
    const {
        id,
        companyName,
        type,
        stateId,
        isActive,
        extSystemIdentifier,
        extSystemName,
        activeInactiveDate,
        activeInactiveUser,
        name,
        addressLine1,
        addressLine2,
        notes,
        city,
        zip,
        phoneNumber,
        email,
        extSystemIdentifier2,
        isCompliant,
    } = carrier;
    const UNAVAILABLE_DATE = '';
    const [deleteConfirm, setDeleteConfirm] = useState(false);
    const isOdd = index % 2 == 1;
    const containerStyle = `CarriersItem-Bottom-Container ${!isOdd && 'CarriersItem-Bottom-Container-With-Background'}`;
    const handleDelete = () => {
        onDelete && onDelete(carrier);
        setDeleteConfirm(false);
    };
    // const option = options.find(element => element.id == id);

    return (
        <div className={containerStyle}>
            <div className="d-flex flex-column justify-content-between my-flex-container col-md-2">
                <div className="CarriersItem-List-Header">{companyName}</div>
            </div>
            <div className="d-flex flex-column justify-content-between my-flex-container col-md-1">
                <div className="CarriersItem-List-Header">{type}</div>
            </div>
            <div className="d-flex flex-column justify-content-between my-flex-container col-md-1">
                <div className="CarriersItem-List-Header">{isActive ? 'Active' : 'Inactive'}</div>
            </div>
            <div className="d-flex flex-column justify-content-between my-flex-container col-md-2">
                <div className="CarriersItem-List-Header">
                    {activeInactiveDate ? formatDateUtcToLocal(activeInactiveDate) : UNAVAILABLE_DATE}
                </div>
            </div>
            <div className="d-flex flex-column justify-content-between my-flex-container col-md-2">
                <div className="CarriersItem-List-Header">{activeInactiveUser}</div>
            </div>
            <div className="d-flex flex-column justify-content-between my-flex-container col-md-1">
                <div className="CarriersItem-List-Header">{extSystemIdentifier}</div>
            </div>
            <div className="d-flex flex-column justify-content-between my-flex-container col-md-1">
                <div className="CarriersItem-List-Header">{extSystemIdentifier2}</div>
            </div>
            <div className="d-flex flex-column justify-content-between my-flex-container col-md-1">
                <div className="CarriersItem-List-Header">{isCompliant ? 'Compliant' : 'Not Compliant'}</div>
            </div>
            {!canEditCarriers && <div className="GridViewItem-List-Header"></div>}
            {canEditCarriers && (
                <div className="GridViewItem-List-Header">
                    {(canEditCarriers && canAddEditLogisticsPartner) ? (
                        <div
                            className={` ${
                                (canEditCarriers && canAddEditLogisticsPartner) ? 'GridViewItem-Edit-Container' : 'GridViewItem-Edit-Container-Disable'
                            }`}
                            onClick={() => onEditClick(carrier)}
                        >
                            <i className="material-icons UsersItem-Icon">edit</i>
                            <span className="UsersItem-Link">Edit</span>
                        </div>
                    ):(
                        (canEditCarriers && !canAddEditLogisticsPartner) && (
                            <div
                                className={` ${
                                    (canEditCarriers && !canAddEditLogisticsPartner && type!='LP') ? 'GridViewItem-Edit-Container' : 'GridViewItem-Edit-Container-Disable'
                                }`}
                                onClick={() => onEditClick(carrier)}
                            >
                                <i className="material-icons UsersItem-Icon">edit</i>
                                <span className="UsersItem-Link">Edit</span>
                            </div>
                        )
                    )}
                    &nbsp;|&nbsp;
                    {(canEditCarriers && canAddEditLogisticsPartner) && onDelete ? (
                        <div                             
                            className={` ${
                                ((canEditCarriers && canAddEditLogisticsPartner)) ? 'GridViewItem-Edit-Container' : 'GridViewItem-Edit-Container-Disable'
                            }`}
                            onClick={() => setDeleteConfirm(true)} >
                            <i className="material-icons UsersItem-Icon">delete</i>
                            <span className="UsersItem-Link">Delete</span>
                        </div>
                    ):(
                        (canEditCarriers && !canAddEditLogisticsPartner && onDelete) && (
                            <div                             
                                className={` ${
                                    (canEditCarriers && !canAddEditLogisticsPartner && type!='LP') ? 'GridViewItem-Edit-Container' : 'GridViewItem-Edit-Container-Disable'
                                }`}
                                onClick={() => setDeleteConfirm(true)} >
                                <i className="material-icons UsersItem-Icon">delete</i>
                                <span className="UsersItem-Link">Delete</span>
                            </div>
                        ))
                    }
                </div>
            )}
            {(canAddEditLogisticsPartner && !canEditCarriers) && (
                <div className="GridViewItem-List-Header">
                    {canAddEditLogisticsPartner && (
                        <div
                            className={` ${
                                (canAddEditLogisticsPartner && type =='LP') ? 'GridViewItem-Edit-Container' : 'GridViewItem-Edit-Container-Disable'
                            }`}
                            onClick={() => onEditClick(carrier)}
                        >
                            <i className="material-icons UsersItem-Icon">edit</i>
                            <span className="UsersItem-Link">Edit</span>
                        </div>
                    )}
                    &nbsp;|&nbsp;
                    {canAddEditLogisticsPartner && onDelete && (
                        <div                             
                            className={` ${
                                (canAddEditLogisticsPartner && type =='LP') ? 'GridViewItem-Edit-Container' : 'GridViewItem-Edit-Container-Disable'
                            }`}
                            onClick={() => setDeleteConfirm(true)} >
                            <i className="material-icons UsersItem-Icon">delete</i>
                            <span className="UsersItem-Link">Delete</span>
                        </div>
                    )}
                </div>
            )}
            <DeleteModal
                show={deleteConfirm}
                name={'carrier'}
                onConfirm={handleDelete}
                onCancel={() => setDeleteConfirm(false)}
            />
        </div>
    );
};

export default CarrierItem;

